import WaterMark from "component/design-system/WaterMark";
import PAImage from "component/design-system/images/PAImage";
import { useTranslation } from "next-i18next";
import { getProductHeading } from "util/product/get-product-heading";
import { getThumbnailSrcV2 } from "../../../../../util/product/getThumbmailSrc";
import styles from "./product-thumbnail.module.scss";

const ProductThumbnail = ({ product = {}, size }: any) => {
  const { t } = useTranslation("common");
  const thumbnailAltText = `Purchase ${getProductHeading(product)}`;
  return (
    <div className={styles.image_wrapper}>
      {product.outOfStock && (
        <WaterMark label={t("OUT OF STOCK")} fontSize={5} />
      )}

      <PAImage
        src={getThumbnailSrcV2(product)}
        width={size}
        height={size}
        alt={thumbnailAltText}
        title={thumbnailAltText}
      />
    </div>

  );
};

export default ProductThumbnail;
